import { createContext, useContext, useEffect, useState } from "react";
import { AuthContext } from "./AuthContext";
import {
  userApiUrl,
} from "../utils/GetUrl";
export const UserContext = createContext();

export const UserContextProvider = ({ children }) => {
  const [usersList, setUsersList] = useState();
  const [allUsersList, setAllUsersList] = useState();
  const [teamsData, setTeamsData] = useState([]);
  const [teamNames, setTeamNames] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);
  const { token, userData, isLoading, handleAuthExpiry } = useContext(AuthContext);
  const currentEmployeeId = userData?.[0]?.EM_ID;

  const fetchData = async () => {
    if (!token || isLoading || !currentEmployeeId) {
      return;
    }
    setUsersLoading(true);
    try {
      const response = await fetch(`${userApiUrl}/GetAllEmp`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.status === 401) {
        await handleAuthExpiry();
        return;
      }
      if (!response.ok) {
        console.error("GetAllEmp failed:", response.status);
        return;
      }
      const data = await response.json();
      const list = Array.isArray(data) ? data : [];
      fetchTeams(token);
      setAllUsersList(list);
      setUsersList(
        list
          .filter(item => !item.EM_TerminationDate || new Date(item.EM_TerminationDate) > new Date())
          .sort((a, b) => (a.EM_FirstName ?? "").localeCompare(b.EM_FirstName ?? ""))
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setUsersLoading(false);
    }
  };

  const fetchTeams = async (token) => {
    if (!token || isLoading || !currentEmployeeId) {
      return;
    }
    try {
      const response = await fetch(`${userApiUrl}/GetTeams`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) {
        console.error("GetTeams failed:", response.status);
        return;
      }
      const data = await response.json();
      const list = Array.isArray(data) ? data : [];

      const groupedTeams = list.reduce((acc, _, index) => {
        const teams = list.filter((t) => t?.superTeamId === index);
        acc[index] = teams;
        return acc;
      }, {});

      const filtered = Object.values(groupedTeams);
      setTeamsData(filtered);
      setTeamNames(list);
      return filtered;
    } catch (error) {
      console.error("Error fetching teams:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [token, isLoading, currentEmployeeId]);
  return (
    <UserContext.Provider
      value={{
        usersList,
        setUsersList,
        teamsData,
        setTeamsData,
        teamNames,
        setTeamNames,
        fetchTeams,
        fetchData,
        allUsersList,
        usersLoading,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
